export default {
  // Dialog Title
  dialogTitle: "Add Model Verification Address",

  // Form Labels
  modelType: "Model Type:",
  blockchain: "Blockchain:",
  caseName: "Case Name:",
  address: "Address:",

  // Placeholders
  selectModelType: "Please select model type",
  selectBlockchain: "Please select blockchain",
  selectCaseName: "Please select case name",
  inputAddress: "Please enter address",

  // Model Types
  firstFeeFeeModel: "First Fee Model",
  relatedFeeModel: "Related Fee Model",
  tornadoModel: "Tornado Model",

  // Buttons
  reset: "Reset",
  add: "Add",

  // Warning
  warningInfo:
    "Batch address verification is supported. Please note the batch address input format, add spaces or line breaks between addresses",

  // Form Validation
  inputAddressRequired: "Please enter address",
  selectModelTypeRequired: "Please select model type",
  selectBlockchainRequired: "Please select blockchain",
  selectCaseNameRequired: "Please select case name",

  // Messages
  professionalFeature:
    "This feature is only available for professional users. Please contact customer service for consultation.",
  submitSuccess: "Submission successful, please wait for results",
  addModelSuccess: "Model verification added successfully",
  tip: "Tip",
  confirm: "Confirm",
  cancel: "Cancel",
};

